var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-field',{model:{value:(_vm.sortKey),callback:function ($$v) {_vm.sortKey=$$v},expression:"sortKey"}},_vm._l((_vm.sortOptions),function(option){return _c('option',{key:option.key,domProps:{"value":option.key}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }